import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';

export default function CategoryScroller({
  categories = [],
  selected = 'all',
  onSelect = () => {},
}) {
  const scrollRef = useRef(null);

  // DRAG STATE
  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [canScroll, setCanScroll] = useState(false);

  // DRAG START
  const handleMouseDown = (e) => {
    setIsDown(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const endDrag = () => setIsDown(false);

  // DRAG MOVE
  const handleMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 1; // DRAG
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  // SCROLL BUTTONS
  const scrollLeftBtn = () => {
    scrollRef.current.scrollTo({ left: scrollRef.current.scrollLeft - 200, behavior: 'smooth' });
  };

  const scrollRightBtn = () => {
    scrollRef.current.scrollTo({ left: scrollRef.current.scrollLeft + 200, behavior: 'smooth' });
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const updateScrollState = () => setCanScroll(el.scrollWidth > el.clientWidth);
    updateScrollState();
    window.addEventListener('resize', updateScrollState);
    return () => window.removeEventListener('resize', updateScrollState);
  }, [categories]);

  return (
    <div className="relative w-full">
      {canScroll && (
        <button
          onClick={scrollLeftBtn}
          className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md border rounded-full p-1 hover:bg-gray-100"
        >
          <ChevronLeft size={18} />
        </button>
      )}

      {canScroll && (
        <button
          onClick={scrollRightBtn}
          className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md border rounded-full p-1 hover:bg-gray-100"
        >
          <ChevronRight size={18} />
        </button>
      )}

      <div
        ref={scrollRef}
        className="overflow-x-auto scrollbar-hide py-2 cursor-grab select-none w-11/12 mx-auto"
        onMouseDown={handleMouseDown}
        onMouseUp={endDrag}
        onMouseLeave={endDrag}
        onMouseMove={handleMouseMove}
      >
        <div className="flex items-center gap-3 flex-nowrap">
          {categories.map((c) => (
            <button
              key={c.slug}
              onClick={() => onSelect(c.slug)}
              className={`px-4 py-2 whitespace-nowrap rounded-full text-xs sm:text-sm font-semibold border transition ${
                selected === c.slug
                  ? 'bg-accent-200 text-accent-800 border-accent-600 shadow-md'
                  : 'bg-white text-gray-700 border-gray-300 hover:bg-accent-100 hover:text-accent-800 hover:border-accent-600'
              }`}
            >
              {c.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
